var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F5A623",
  fillRule: "evenodd",
  d: "M5.871 18.54a1.05 1.05 0 0 0 .276 1.19c.337.296.825.344 1.213.12l4.39-2.475a.5.5 0 0 1 .49 0l4.397 2.484c.388.225.876.177 1.213-.12a1.05 1.05 0 0 0 .276-1.19l-1.775-4.09a.5.5 0 0 1 .126-.574l3.193-2.826a.98.98 0 0 0-.686-1.71H15.32c-.2 0-.38-.119-.459-.302l-1.924-4.473a1.056 1.056 0 0 0-1.878 0L9.138 9.047a.5.5 0 0 1-.457.302H5.017a.981.981 0 0 0-.69 1.71l3.193 2.83a.5.5 0 0 1 .127.574z"
})));
export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "static/media/star.0b522350.svg";